import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-boton-action',
  templateUrl: './boton-action.component.html',
  styleUrls: ['./boton-action.component.scss']
})
export class BotonActionComponent implements OnInit {

  private _disabled: boolean;
  @Input() set disabled(value: boolean) {
    this._disabled = value;
  }
  get disabled(): boolean {
    return this._disabled;
  }

  private _color: string;
  @Input() set color(value: string) {
    this._color = value;
  }
  get color(): string {
    return this._color;
  }

  private _icono: string;
  @Input() set icono(value: string) {
    this._icono = value;
  }
  get icono(): string {
    return this._icono;
  }

  private _icono_weight: string = 'normal';
  @Input() set iconoWeight(value: string) {
    this._icono_weight = value;
  }
  get iconoWeight(): string {
    return this._icono_weight;
  }

  private _texto: string;
  @Input() set texto(value: string) {
    this._texto = value;
  }
  get texto(): string {
    return this._texto;
  }

  private _tooltipDir: string = 'below';
  @Input() set tooltipDir(value: string) {
    this._tooltipDir = value;
  }
  get tooltipDir(): string {
    return this._tooltipDir;
  }


  private _type: string;
  @Input() set type(value: string) {
    this._type = value;
  }
  get type(): string {
    return this._type;
  }

  private _action: any;
  @Input() set action(value: any) {
    this._action = value;
  }
  get action(): any {
    return this._action;
  }

  private _parametros: any;
  @Input() set parametros(value: any) {
    this._parametros = value;
  }
  get parametros(): any {
    return this._parametros;
  }

  constructor() { }

  ngOnInit() {
  }

  click() {
    this.action(this.parametros);
  }
}
